module.exports = __webpack_public_path__ + "static/media/icon_robot_ia.5b12513b.svg";